import { Text } from '@change/ds-core-ui/next';

import { buttonSelected, buttonStyles } from '../SelectionCard.styles';

import { Badge } from './Badge';
import { GradientBorder } from './GradientBorder';
import type { ItemPriceProps } from './ItemPrice.types';

export const ItemPrice: React.FC<ItemPriceProps> = ({
	value,
	badge,
	metaText,
	label,
	selected,
	localizedValue,
	onClick,
}: ItemPriceProps) => {
	return (
		<GradientBorder selected={selected}>
			<button
				className={selected ? buttonSelected.join(' ') : buttonStyles.join(' ')}
				type="button"
				onClick={() => onClick(value)}
			>
				<div className="w-full">
					<Badge position="top" badge={badge} />
					<div className="flex flex-row justify-between pb-1.5">
						<div className="flex flex-row gap-2">
							{metaText && (
								<Text variant="body" size="medium" className="text-typography-weak line-through">
									{metaText}
								</Text>
							)}
							<Text variant="body" size="medium" fontWeight="bold">
								{label}
							</Text>
						</div>
						{localizedValue && (
							<Text variant="body" size="medium" fontWeight="bold">
								{localizedValue}
							</Text>
						)}
					</div>
					<Badge position="bottom" badge={badge} />
				</div>
			</button>
		</GradientBorder>
	);
};
